
// Coordonnées de Paris
function CCTMapSearch(options, handle="", template_suffix = "", type_search = "carte_cadeau") {
    if(!options){
        options = {
            "city":"",
            "latitude":48.8566,
            "longitude":2.3522,
            "zoom": 12
        }
    }

    this.type_search = type_search
    this.options = options
    this.template_suffix = template_suffix +'|'+handle;
    this.handle = handle;
   
    console.log({
        options:this.options,
        handle:this.handle,
        template_suffix:this.template_suffix,
        session: JSON.parse(sessionStorage.getItem("map_search"))
    })

    if(sessionStorage.getItem("map_search") &&  !this.template_suffix.includes('NONE')){
        let mapSearchSessionStorage = JSON.parse(sessionStorage.getItem("map_search"))
        if(!!mapSearchSessionStorage[this.template_suffix] && Object.values(mapSearchSessionStorage[this.template_suffix]).length > 0){
            this.options = mapSearchSessionStorage[this.template_suffix]
        }
     }

    const mapStyles = [
        { elementType: "labels", stylers: [{ visibility: "on" }] },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
        { featureType: "road", stylers: [{ visibility: "on" }] },
        // { featureType: "water", stylers: [{ color: "#b3e5fc" }] }, // Optionnel : Modifier la couleur de l'eau
        // { featureType: "landscape", stylers: [{ color: "#e5e5e5" }] }, // Optionnel : Modifier la couleur du paysage
    ];
    this.positionCurrent = {
        center: { lat: this.options.latitude, lng: this.options.longitude }, // Coordonnées de Paris
        zoom: this.options.zoom,
        gestureHandling: "greedy",
        styles: mapStyles,
        disableDefaultUI: true
    }
    
    //console.log({poscurrent:this.positionCurrent})
    this.markers = [];
    this.init();
}

CCTMapSearch.prototype = {
    _:{
        selectors:{
        },
        messages: { }
    },
    searchClient: undefined,
    restaurantsIndex: undefined,
    restaurantsSearch: undefined,
    emit:function(name){
        var colorBG = "#1e98ec"
        console.log("%c→ EMIT CCTMapSearch." + name,"background:"+colorBG+";color:#FFF")
        console.log({arguments})
        $(document).trigger('CCTMapSearch.'+name,arguments);
    },
    delay: async function(ms){
        return new Promise(resolve => setTimeout(resolve, ms))
    },
    toggle_map_search:function(evt){
        // console.log("toggle_map_search")
        if($("#map_agolia").hasClass('hidden')){
            $("#map_agolia").removeClass("hidden")

            if($("#backButton").length === 0){
                $("#map_agolia").append(`<button id="backButton" class="js-open_map_search" >Afficher la liste <div class="list_picto"><div></button>`)
            }

        }else{
            $("#map_agolia").addClass("hidden")
        }
    },
    init:async function () {
        this.DEBUGLOG = false
        console.log("%cSTART CCT.map-search", "background:cyan;color:#333")
        //  $("#MainContent").css("margin-top",$("header").height())
        $(".js-open_map_search").removeClass("hidden")
        this.bindEvents();
      //  console.log({optinit:this.options})
        if(!!this.options.city && this.options.city!==""){
            await this.getCoordinatesFromCity(this.options.city+", France")
                .then(({ lat, lng }) => {
                    this.options.latitude = lat;
                    this.options.longitude = lng;
                    this.positionCurrent.center.lat= lat;
                    this.positionCurrent.center.lng= lng;
                })
                .catch((error) => console.error("Erreur lors de la récupération des coordonnées :", error));
        }
        await this.initMap();
        await this.addMarker();
    },
    getCoordinatesFromCity:async function(cityName) {
        const geocodingLib = await google.maps.importLibrary("geocoding")
        return new Promise( (resolve, reject) => {
            const geocoder = new geocodingLib.Geocoder();
            geocoder.geocode({address: cityName}, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                    const location = results[0].geometry.location;
                    resolve({
                        lat: location.lat(),
                        lng: location.lng()
                    });
                } else {
                    reject(new Error("Ville introuvable ou erreur de géocodage : " + status));
                }
            });
        });
    },
    saveMapSearchSessionStorage(handle, datas){
        //save mes nouveau filtre dans le localstorage pour le trie
        let mapSearchSessionStorage = JSON.parse(sessionStorage.getItem("map_search")) || {}
        mapSearchSessionStorage[handle]=datas
        sessionStorage.setItem("map_search", JSON.stringify(mapSearchSessionStorage))
    },
    addMarker:async function(){
        this.searchClient = algoliasearch('BKOWC37603', '8fc576812f9182106f19995631767c72');
        this.restaurantsIndex = this.searchClient.initIndex('restaurants_index');
        this.restaurantsSearch = instantsearch({
            indexName: 'restaurants_index',
            searchClient:this.searchClient
        });
        this.map.addListener('idle', () => {
            const bounds = this.map.getBounds(); // Récupérer les bounds actuels de la carte
            const northEast = bounds.getNorthEast();
            const southWest = bounds.getSouthWest();

            let centerMapCurrent = this.map.getCenter();
            let zoomMapCurrent = this.map.getZoom();

            this.saveMapSearchSessionStorage(this.template_suffix,{
                "city":"",
                "latitude":centerMapCurrent.lat(),
                "longitude":centerMapCurrent.lng(),
                "zoom":zoomMapCurrent
            })
        
            // Convertir les coordonnées en nombres flottants bien formatés
            const neLat = parseFloat(northEast.lat());
            const neLng = parseFloat(northEast.lng());
            const swLat = parseFloat(southWest.lat());
            const swLng = parseFloat(southWest.lng());
            //  Effectuez une recherche sur Google ou saisissez une URL
            const boundingBox =[neLat,swLng,swLat,neLng]
            // Effectuer une recherche Algolia avec la boîte englobante dynamique

            window.restaurantsIndex= this.restaurantsIndex

            let filter_offre="validated=1 AND price_min>0 "
            if(this.type_search ==="cours_de_cuisine"){ 
                filter_offre="validated=1 AND price_min_cours_de_cuisine>0 AND offre_cours_de_cuisine=1 "  
            }else if(this.type_search ==="carte_cadeau"){
                filter_offre="validated=1 AND price_min_carte_cadeau>0 AND offre_carte_cadeau=1 "  
            }

            this.restaurantsIndex.search('', {
                insideBoundingBox: [boundingBox],
                filters: filter_offre,
                hitsPerPage: 20
            }).then(({hits}) => {
                this.updateMapWithHits(this.map, hits);
            }).catch(err => {
                console.error('Algolia search error:', err);
            });
        })
        this.restaurantsSearch.start()

    },
    initMap:async function() {
        const { Map  } = await google.maps.importLibrary("maps");
    //    console.log({posCurrent: this.positionCurrent})
        this.map = new Map(document.getElementById("map_agolia"), this.positionCurrent);
        this.addYourLocationButton()
    },
    addYourLocationButton:function ()
    {
        var controlDiv = document.createElement('div');
        controlDiv.className="area-btn-position"

        var firstChild = document.createElement('button');
        firstChild.style.backgroundColor = '#fff';
        firstChild.style.border = 'none';
        firstChild.style.outline = 'none';
        firstChild.style.width = '28px';
        firstChild.style.height = '28px';
        firstChild.style.borderRadius = '2px';
        firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
        firstChild.style.cursor = 'pointer';
        firstChild.style.marginRight = '10px';
        firstChild.style.padding = '0';
        firstChild.title = 'Votre position';
        firstChild.className="js-ma-btn-position"
        controlDiv.appendChild(firstChild);

        var secondChild = document.createElement('div');
        secondChild.style.margin = '5px';
        secondChild.style.width = '18px';
        secondChild.style.height = '18px';
        secondChild.style.backgroundImage = 'url(//tiptoque.com/cdn/shop/t/45/assets/mylocation-sprite-2x_small.png?v=70739118576141007191744619342)';
        secondChild.style.backgroundSize = '180px 18px';
        secondChild.style.backgroundPosition = '0 0';
        secondChild.style.backgroundRepeat = 'no-repeat';
        secondChild.className = 'picto_position';
        firstChild.appendChild(secondChild);

        google.maps.event.addListener(this.map, 'center_changed', function () {
            secondChild.style['background-position'] = '0 0';
        });

        controlDiv.index = 1;
        controlDiv.style.position= "absolute";

        if(!$(".supports-mobile").length){
            controlDiv.style.top= "200px";
            controlDiv.style.right= "30px";
        }else{
            controlDiv.style.top= "150px";
            controlDiv.style.right= "0px";
        }


        var mapFrame = document.getElementById('map_agolia');
        mapFrame.appendChild(controlDiv);
        //  this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(controlDiv);
    },
    click_position:function(evt){
        let secondChild = document.querySelector(".picto_position")
        var imgX = '0',
            animationInterval = setInterval(function () {
                imgX = imgX === '-18' ? '0' : '-18';
                secondChild.style['background-position'] = imgX+'px 0';
            }, 500);
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var latlng = new google.maps.LatLng(
                    position.coords.latitude,
                    position.coords.longitude);
                this.map.setCenter(latlng);
                clearInterval(animationInterval);
                secondChild.style['background-position'] = '-144px 0';
            }.bind(this));
        } else {
            clearInterval(animationInterval);
            secondChild.style['background-position'] = '0 0';
        }
    },
    updateMapWithHits:function(map, hits) {
        const self = this; 

        // Supprimer tous les marqueurs actuels
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
        // Parcourir les résultats Algolia et créer des marqueurs
        hits.forEach(hit => {
            let position = { lat: hit._geoloc.lat, lng: hit._geoloc.lng }
            const overlay = new google.maps.OverlayView();
            overlay.onAdd = function () {
                // Créer l'élément div pour le marqueur
                const markerDiv  = document.createElement("div");
                markerDiv.className = "custom-marker js-ma-marker-open";
                markerDiv.dataset.handle = `${hit.handle}`;


                let price_min_current=hit.price_min
                let url_page=hit.url
                if(self.type_search == "cours_de_cuisine"){ 
                    url_page=hit.url_cc
                    price_min_current=hit.price_min_cours_de_cuisine
                }else if(self.type_search ==="carte_cadeau"){
                    url_page=hit.url
                    price_min_current=hit.price_min_carte_cadeau
                }
                console.log(self.type_search,hit)
                markerDiv.textContent = `${price_min_current} €`;

                // Créer l'élément div pour la popup
                const popupDiv = document.createElement("div");
                popupDiv.className = "am-popup js-ma-popup-open";
                popupDiv.dataset.handle = `${hit.handle}`;

                let distinctions_html =''
                if(!!hit.distinctions ){
                    for (let distinction of hit.distinctions) {
                        if( distinction.count > 0){
                            distinctions_html += `<div class="am-picto" style="background-image: url('${distinction.icon}')"></div>`.repeat(distinction.count)
                        }
                    }
                }
                popupDiv.innerHTML  = ` <div class="am-close js-am-btn-close" ></div>
                                        <a  href="${url_page}">
                                          <div class="am-content_image">
                                              <div class="am-image" style="background-image: url('${hit.image}')">
                                              </div>
                                          </div>
                                          <div class="am-content">
                                              <div class="am-title"> ${hit.name} ${distinctions_html}</div>
                                              <div class="am-address">
                                                  <div class="am-address-place">${hit.adresse}</div>
                                                  <div class="am-address-city">${hit.zip} ${hit.city}</div>
                                              </div>
                                          </div>
                                       </a>`;

                // Ajouter l'élément div au DOM
                const panes = this.getPanes();
                panes.overlayMouseTarget.appendChild(markerDiv); // Cible des événements de la souris

                if($(".supports-mobile").length) {
                    console.log("Mobile Support Valide")
                    //ajouter out map pour etre fix
                    let mapAgolia =  document.getElementById("map_agolia");
                    mapAgolia.appendChild(popupDiv);
                }else{
                    console.log("Mobile Support pas valide")
                    //ajouter sur la map et interaction au mouvement
                    panes.overlayMouseTarget.appendChild(popupDiv);
                }
                //  console.log(markerDiv.offsetWidth/2)
                // Positionner et actualiser le marqueur
                overlay.draw = function () {
                    const projection = this.getProjection();
                    

                    const pos = projection.fromLatLngToDivPixel(position);
                    markerDiv.style.left = pos.x + "px";
                    markerDiv.style.top = pos.y + "px";

                    if(!$(".supports-mobile").length){
                        const isAboveCenter = position.lat > this.map.getCenter().lat();
                        popupDiv.style.left = (pos.x + markerDiv.offsetWidth/2) + "px";
                        if (isAboveCenter) {
                            //    console.log( markerDiv.offsetHeight , popupDiv.offsetHeight)
                            //markerDiv.offsetHeight + popupDiv.offsetHeight
                            popupDiv.style.top = (pos.y + (20 + 28 + 275  )) + "px";
                        } else {
                            popupDiv.style.top = (pos.y - 20 ) + "px";
                        }
                    }

                };

                // Supprimer le marqueur du DOM
                overlay.onRemove = function () {
                    markerDiv.parentNode.removeChild(markerDiv);
                    popupDiv.parentNode.removeChild(popupDiv);
                };
            };
            // Afficher l'overlay sur la carte
            overlay.setMap(map);
        });
    },
    click_map:function(evt){
        let popupDivAll = document.querySelectorAll(".js-ma-popup-open");
        popupDivAll.forEach(el => el.style.display= "none")
        let markerDivAll = document.querySelectorAll(".js-ma-marker-open");
        markerDivAll.forEach(el => el.classList.remove("active"))
    },
    toggle_info_restaurant:function (evt){
        evt.stopPropagation();
        let markerDiv = evt.currentTarget
        let marketDivHandle = markerDiv.dataset.handle

        let markerDivAll = document.querySelectorAll(".js-ma-marker-open");
        markerDivAll.forEach(el =>{
            if(el.dataset.handle !== marketDivHandle){
                el.classList.remove("active")
            }else{
                el.classList.add("active")
            }
        })

        let popupDivAll = document.querySelectorAll(".js-ma-popup-open");
        popupDivAll.forEach(el => {
            if(el.dataset.handle !== marketDivHandle){
                el.style.display = "none"
            }else{
              //  console.log(el)
                el.style.display = "block"
            }
        })

    },
    bindEvents:function(){
        $("body")
            .off("click.open_map_search").on("click.open_map_search", ".js-open_map_search",_.bind(this.toggle_map_search, this))
            .off("click.open_info_restaurant").on("click.open_info_restaurant", ".js-ma-marker-open",_.bind(this.toggle_info_restaurant, this))
            .off("click.move_map").on("click.move_map", "#map_agolia",_.bind(this.click_map, this))
            .off("click.btn_position").on("click.btn_position", ".js-ma-btn-position",_.bind(this.click_position, this))
        //   .off("click.open_info_restaurant").on("click.open_info_restaurant", ".js-ma-popup-open",_.bind(this.toggle_map_search, this))

    }


}

